module.exports = __webpack_public_path__ + "static/media/M.Eliyeva.fa14136a.jpg";